// @ts-nocheck
/*
 * Viti Vinci — PDP add-to-cart + mobile gallery autoplay.
 * AJAX add, then flip the button to the "Added" state for 2s.
 * On mobile (<=899px) the gallery auto-rotates every 4s; pauses on touch.
 */
(function () {
  let resetTimer = null;

  // Build the "available" (clickable buy) button markup, optionally
  // swapping in a per-variant label override (custom.cta_button_label
  // metafield). Blank override → the default template markup unchanged.
  const availableTemplateEl = document.querySelector('[data-vv-add-button-available]');
  const DEFAULT_AVAILABLE_HTML =
    availableTemplateEl instanceof HTMLTemplateElement ? availableTemplateEl.innerHTML : '';
  function availableHtmlWithLabel(overrideLabel) {
    if (!overrideLabel || !DEFAULT_AVAILABLE_HTML) return DEFAULT_AVAILABLE_HTML;
    const tmp = document.createElement('div');
    tmp.innerHTML = DEFAULT_AVAILABLE_HTML;
    const lbl = tmp.querySelector('.cta__label');
    if (lbl) lbl.textContent = overrideLabel;
    return tmp.innerHTML;
  }

  // ---------- Mobile gallery autoplay ----------
  const mobileMQ = window.matchMedia('(max-width: 899px)');
  const gallery = document.querySelector('.vv-product__gallery');
  if (gallery) {
    const slides = gallery.querySelectorAll('.vv-product__media');
    let timer = null;
    let paused = false;
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => {
      stop();
      if (!mobileMQ.matches || slides.length < 2 || paused) return;
      timer = setInterval(() => {
        const w = gallery.clientWidth || 1;
        const next = Math.round(gallery.scrollLeft / w) + 1;
        const target = next >= slides.length ? 0 : next;
        gallery.scrollTo({ left: target * w, behavior: 'smooth' });
      }, 4000);
    };
    gallery.addEventListener('touchstart', () => { paused = true; stop(); }, { passive: true });
    gallery.addEventListener('touchend', () => { paused = false; start(); }, { passive: true });
    mobileMQ.addEventListener('change', start);
    start();
  }

  // ---------- Size picker dropdown ----------
  document.querySelectorAll('[data-vv-size-picker]').forEach(function (picker) {
    const trigger = picker.querySelector('[data-vv-size-trigger]');
    const labelEl = picker.querySelector('[data-vv-size-label]');
    const dropdown = picker.querySelector('[data-vv-size-dropdown]');
    // The size picker now lives OUTSIDE the product form (we
    // refactored so the customer "register interest" form can be a
    // sibling without nesting). So look up the ATC form + templates
    // document-wide instead of via picker.closest('form').
    const pickerForm = document.querySelector('.vv-product__form');
    const hiddenInput = pickerForm && pickerForm.querySelector('input[name="id"]');
    const addButton = document.querySelector('[data-vv-add-to-cart]');
    const unavailableTemplate = document.querySelector('[data-vv-add-button-unavailable]');
    const comingSoonTemplate = document.querySelector('[data-vv-add-button-coming-soon]');
    const PLACEHOLDER = picker.dataset.vvSizePlaceholder || (labelEl && labelEl.textContent.trim()) || '';
    let currentLabel = PLACEHOLDER;

    function openPicker() {
      picker.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
      if (labelEl) labelEl.textContent = PLACEHOLDER;
    }
    function closePicker() {
      picker.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (labelEl) labelEl.textContent = currentLabel;
    }

    trigger.addEventListener('click', function () {
      if (picker.hasAttribute('data-open')) closePicker();
      else openPicker();
    });

    dropdown.querySelectorAll('.vv-size-picker__option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        const variantId = opt.dataset.variantId;
        const variantLabel = opt.dataset.variantLabel;
        const variantAvailable = opt.dataset.variantAvailable === 'true';
        const variantComingSoon = opt.dataset.variantComingSoon === 'true';
        const variantCtaLabel = opt.dataset.variantCtaLabel || '';

        dropdown.querySelectorAll('.vv-size-picker__option').forEach(function (o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-selected', 'false');
          o.style.background = '';
          o.style.color = '';
        });
        opt.classList.add('is-selected');
        opt.setAttribute('aria-selected', 'true');
        opt.style.background = '#262733';
        opt.style.color = '#F5F0E8';

        currentLabel = variantLabel;
        if (hiddenInput) hiddenInput.value = variantId;
        updateAddButtonForVariant(variantAvailable, variantComingSoon, variantCtaLabel);
        toggleRegisterForm(variantComingSoon, variantId);
        closePicker();
      });
    });

    document.addEventListener('click', function (e) {
      if (!picker.contains(e.target)) closePicker();
    });

    function updateAddButtonForVariant(isAvailable, isComingSoon, ctaLabel) {
      if (!addButton) return;

      // Three states:
      //   - Coming Soon (11ml pre-launch): solid-dark colours but
      //     disabled. NO :hover invert (handled in CSS via
      //     :disabled :not([aria-busy='true'])). Looks like Add to Bag.
      //   - Out of Stock (variant unavailable): muted (beige).
      //   - Available: solid-dark, clickable, full hover behaviour.

      clearTimeout(resetTimer);
      resetTimer = null;
      addButton.removeAttribute('aria-busy');
      addButton.classList.remove('cta--solid-cream');

      if (isComingSoon) {
        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');
        addButton.dataset.currentVariantAvailable = 'false';
        addButton.classList.add('cta--solid-dark');
        addButton.classList.remove('cta--muted');
      } else if (isAvailable) {
        addButton.disabled = false;
        addButton.setAttribute('aria-disabled', 'false');
        addButton.dataset.currentVariantAvailable = 'true';
        addButton.classList.add('cta--solid-dark');
        addButton.classList.remove('cta--muted');
      } else {
        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');
        addButton.dataset.currentVariantAvailable = 'false';
        addButton.classList.remove('cta--solid-dark');
        addButton.classList.add('cta--muted');
      }

      if (isComingSoon) {
        // Coming Soon / Out of Stock ignore the per-variant override.
        addButton.dataset.availableLabel = '';
        const template = comingSoonTemplate || unavailableTemplate;
        if (template instanceof HTMLTemplateElement) addButton.innerHTML = template.innerHTML;
      } else if (isAvailable) {
        // Persist the override so the post-"Added" revert restores it.
        addButton.dataset.availableLabel = ctaLabel || '';
        addButton.innerHTML = availableHtmlWithLabel(ctaLabel);
      } else {
        addButton.dataset.availableLabel = '';
        if (unavailableTemplate instanceof HTMLTemplateElement) addButton.innerHTML = unavailableTemplate.innerHTML;
      }
    }

    // Show / hide the register-interest form based on whether the
    // currently selected variant is in the Coming Soon state. The
    // form's variant-id hidden field is also updated so the customer
    // record's note reflects which size they registered for.
    function toggleRegisterForm(isComingSoon, variantId) {
      const wrap = document.querySelector('[data-vv-register-wrap]');
      if (!wrap) return;
      if (isComingSoon) {
        wrap.removeAttribute('hidden');
      } else {
        wrap.setAttribute('hidden', '');
      }
      const noteField = wrap.querySelector('input[name="contact[note]"]');
      if (noteField && variantId) {
        noteField.value = 'Registered interest from PDP — variant id ' + variantId;
      }
    }
  });

  // ---------- PDP accordion smooth open/close ----------
  document.querySelectorAll('.vv-product__accordion').forEach(function (accordion) {
    const detailsItems = Array.from(accordion.querySelectorAll('details.details'));

    detailsItems.forEach(function (details) {
      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          detailsItems.forEach(function (item) {
            if (item !== details) {
              item.open = false;
              item.querySelector('summary')?.setAttribute('aria-expanded', 'false');
            }
          });
          details.open = !details.open;
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
          return;
        }

        if (details.open) {
          closeDetails(details);
          return;
        }

        detailsItems.forEach(function (item) {
          if (item !== details && item.open) closeDetails(item);
        });
        openDetails(details);
      });
    });
  });

  function openDetails(details) {
    const content = details.querySelector('.details-content');
    const summary = details.querySelector('summary');
    if (!content) {
      details.open = true;
      summary?.setAttribute('aria-expanded', 'true');
      return;
    }

    content.getAnimations().forEach(function (animation) { animation.cancel(); });
    details.open = true;
    summary?.setAttribute('aria-expanded', 'true');

    content.style.overflow = 'hidden';
    content.style.height = '0px';
    content.style.opacity = '0';

    requestAnimationFrame(function () {
      const targetHeight = content.scrollHeight;
      content.style.height = targetHeight + 'px';
      content.style.opacity = '1';
    });

    onceTransitionEnds(content, function () {
      if (!details.open) return;
      content.style.height = 'auto';
      content.style.overflow = '';
      content.style.opacity = '';
    });
  }

  function closeDetails(details) {
    const content = details.querySelector('.details-content');
    const summary = details.querySelector('summary');
    if (!content) {
      details.open = false;
      summary?.setAttribute('aria-expanded', 'false');
      return;
    }

    content.getAnimations().forEach(function (animation) { animation.cancel(); });
    content.style.overflow = 'hidden';
    content.style.height = content.scrollHeight + 'px';
    content.style.opacity = '1';

    // Force the browser to commit the measured height before collapsing.
    content.offsetHeight;

    requestAnimationFrame(function () {
      content.style.height = '0px';
      content.style.opacity = '0';
    });

    onceTransitionEnds(content, function () {
      details.open = false;
      summary?.setAttribute('aria-expanded', 'false');
      content.style.height = '';
      content.style.overflow = '';
      content.style.opacity = '';
    });
  }

  function onceTransitionEnds(element, callback) {
    let done = false;
    const finish = function () {
      if (done) return;
      done = true;
      element.removeEventListener('transitionend', onEnd);
      clearTimeout(timer);
      callback();
    };
    const onEnd = function (event) {
      if (event.target === element && event.propertyName === 'height') finish();
    };
    const timer = setTimeout(finish, 520);
    element.addEventListener('transitionend', onEnd);
  }

  // ---------- Add-to-cart ----------
  const form = document.querySelector('.vv-product__form');
  const btn = document.querySelector('[data-vv-add-to-cart]');
  if (!form || !btn) return;

  const ADDED_LABEL = btn.dataset.addedLabel || btn.textContent.trim();
  const ADDING_LABEL = btn.dataset.addingLabel || btn.textContent.trim();
  const ERROR_LABEL = btn.dataset.errorLabel || btn.textContent.trim();
  const ADDED_HTML =
    '<span class="cta__icon cta__icon--check svg-wrapper" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">' +
    '<path d="M4 10.5L8 14.5L16 6.5" stroke="currentColor" stroke-width="1.25" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span><span class="cta__label">' + ADDED_LABEL + '</span>';

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    flipToAdding();
    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' },
      });
      if (!addRes.ok) {
        const err = await addRes.json().catch(() => ({}));
        throw new Error(err.description || ERROR_LABEL);
      }

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          detail: {
            resource: cart,
            sourceId: 'vv-product',
            source: 'vv-product',
            itemCount: cart.item_count,
          },
        })
      );

      if (btn.dataset.currentVariantAvailable === 'true') {
        flipToAdded();
      }
    } catch (err) {
      console.error('[vv-product] add to cart failed', err);
      document.dispatchEvent(
        new CustomEvent('cart:error', {
          detail: { source: 'vv-product', message: err.message },
        })
      );
      if (btn.dataset.currentVariantAvailable === 'true') {
        revert();
      }
    }
  });

  function flipToAdding() {
    // VIT-67: do NOT swap label to "Adding..." — the button keeps
    // its current "Add to bag" content (with bag icon) until the
    // fetch resolves and flipToAdded() takes over with the slide
    // animation. The aria-busy attribute still flags the in-flight
    // state for assistive tech.
    btn.classList.add('cta--solid-dark');
    btn.classList.remove('cta--solid-cream', 'cta--muted');
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-disabled', 'true');
  }

  // VIT-67: gate icon slide animation behind .is-animating so page
  // load and hover never trigger a slide. Class is added before the
  // innerHTML swap (so the new icon element matches the animating
  // rule and fires its keyframes), removed after the animation.
  function triggerSlide() {
    btn.classList.add('is-animating');
    setTimeout(function () {
      btn.classList.remove('is-animating');
    }, 500);
  }

  function flipToAdded() {
    triggerSlide();
    btn.classList.remove('cta--solid-dark');
    btn.classList.add('cta--solid-cream');
    btn.removeAttribute('aria-busy');
    btn.innerHTML = ADDED_HTML;
    clearTimeout(resetTimer);
    resetTimer = setTimeout(revert, 2000);
  }

  function revert() {
    triggerSlide();
    btn.removeAttribute('aria-busy');
    btn.classList.remove('cta--solid-cream');
    btn.classList.add('cta--solid-dark');
    btn.classList.remove('cta--muted');
    btn.innerHTML = availableHtmlWithLabel(btn.dataset.availableLabel || '');
    btn.dataset.currentVariantAvailable = 'true';
    btn.disabled = false;
    btn.setAttribute('aria-disabled', 'false');
  }
})();
